/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Meeting_Prep_Actions_Done_OnInputs */



/**
* | output |
* | --- |
* | "completed on {date}" |
*
* @param {Meeting_Prep_Actions_Done_OnInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_actions_done_on = /** @type {((inputs: Meeting_Prep_Actions_Done_OnInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Actions_Done_OnInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`afgerond op ${i?.date}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`terminé le ${i?.date}`)
	return /** @type {LocalizedString} */ (`completed on ${i?.date}`)
});